import { Button, Space, Tooltip } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useProReportingJoinBetaTesting } from "../../../hooks/reporting/useProReportingJoinBetaTesting";
import { useConfirm } from "melco-shared-logic";

interface JoinBetaTestingButtonProps {
  text?: string;
  icon?: React.ReactNode;
  tooltipText?: string;
}

export const JoinBetaTestingButton: React.FC<JoinBetaTestingButtonProps> = ({
  text,
  icon,
  tooltipText,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const proReportingJoinBetaTesting = useProReportingJoinBetaTesting();

  const confirmJoinBetaTesting = useConfirm(
    async () => {
      await proReportingJoinBetaTesting();
      navigate("/reporting");
      window.location.reload();
    },
    {
      translationPrefix: "reporting.proreporting.actions.joinbeta",
      content: (
        <Space direction="vertical" size="small">
          {t("reporting.proreporting.actions.joinbeta.confirmation.message")}
        </Space>
      ),
      width:"50%"
    }
  );

  return (
    <>
      <Tooltip title={tooltipText ? tooltipText : ""}>
        <Button
          key="join-beta-testing"
          type="primary"
          icon={icon ? icon : undefined}
          data-cy-id="join-beta-testing-now-button"
          onClick={async () => {
            confirmJoinBetaTesting();
          }}
        >
          {text ? text : t("reporting.proreporting.button")}
        </Button>
      </Tooltip>
    </>
  );
};
